const store = {
    state: {
        // 会话列表
        datasets: [
            {
                name: '菜单部分',
                component: 'Collapse'
            },
            {
                name: '存储部分',
                component: 'Save'
            }
        ]
    }
};


export default store;



// WEBPACK FOOTER //
// ./src/store/setting.js